import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import { withPopup } from '../../lib/popup';
import { Popup } from '../../lib/custom-ui';

import styles from './UserPopup.module.scss';

const UserStep = React.memo(({ onLogout }) => {
  return (
    <>
      <Popup.Header>操作</Popup.Header>
      <Popup.Content>
        <Menu secondary vertical className={styles.menu}>
          <Menu.Item className={styles.menuItem} onClick={onLogout}>
            退出
          </Menu.Item>
        </Menu>
      </Popup.Content>
    </>
  );
});

UserStep.propTypes = {
  isLogouting: PropTypes.bool.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isPromotion: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired,
  openOrderModal: PropTypes.func.isRequired,
  openDownloadModal: PropTypes.func.isRequired,
};
export default withPopup(UserStep, {
  position: 'bottom right',
});
